<template>
  <div>
    <div v-if="user" id="compdb">
      <nav class="navbar sticky-top navbar-light bg-light">
        <div class="input-group my-2">
          <!-- Search UI Group -->
          <div class="libraries-group-btn row mr-0">
            <button
              type="button"
              class="ml-3 btn btn-info dropdown-toggle"
              data-flip="false"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon icon="hand-pointer" />
              <span class="caret"></span>
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                href="#"
                id="cart"
                v-on:click.prevent="requestTypeChange('cart')"
              >
                Cart
                <span v-if="selectedType === 'cart'">&#x2713;</span>
              </a>
              <a
                class="dropdown-item"
                href="#"
                id="package"
                v-on:click.prevent="requestTypeChange('package')"
              >
                Package
                <span v-if="selectedType === 'package'">&#x2713;</span>
              </a>
              <a
                class="dropdown-item"
                href="#"
                id="genome"
                v-on:click.prevent="requestTypeChange('genome')"
              >
                Genome
                <span v-if="selectedType === 'genome'">&#x2713;</span>
              </a>
              <a
                class="dropdown-item"
                href="#"
                id="library_sequence"
                v-on:click.prevent="requestTypeChange('library_sequence')"
              >
                Sequence
                <span v-if="selectedType === 'library_sequence'">&#x2713;</span>
              </a>
            </div>
            <!-- .dropdown-menu -->
          </div>
          <!-- .libraries-group-btn -->

          <div
            v-if="
              selectedType == 'cart' ||
                (!selectedCart && selectedType == 'package')
            "
            class="add-btn ml-1"
          >
            <button
              type="button"
              class="btn btn-info"
              data-toggle="modal"
              data-target="#addNewItem"
              v-on:click="prepAddItem(item)"
              data-backdrop="static"
              data-keyboard="false"
            >
              <font-awesome-icon icon="plus" />
            </button>
          </div>
          <input
            id="searchTerm"
            placeholder="Search"
            type="text"
            class="form-control ml-1"
            aria-label="Search"
            v-model="searchTerm"
          />

          <div class="search-group-btn">
            <button
              type="button"
              class="ml-1 btn btn-info dropdown-toggle"
              data-flip="false"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon icon="search" />
              <span class="small mt-2 ml-1">{{
                filterKey | searchFilter
              }}</span>
              <span class="caret"></span>
            </button>

            <div class="dropdown-menu dropdown-menu-right">
              <a
                class="dropdown-item"
                href="#"
                id="merge"
                v-on:click.prevent="requestKeyChange('merge')"
              >
                Merge
                <span v-if="filterKey === 'merge'">&#x2713;</span>
              </a>

              <a
                class="dropdown-item"
                href="#"
                id="olab_id"
                v-on:click.prevent="requestKeyChange('olab_id')"
              >
                OLAB ID
                <span v-if="filterKey === 'olab_id'">&#x2713;</span>
              </a>

              <a
                class="dropdown-item"
                href="#"
                id="name"
                v-on:click.prevent="requestKeyChange('name')"
              >
                Name
                <span v-if="filterKey === 'name'">&#x2713;</span>
              </a>

              <a
                v-if="selectedType !== 'genome'"
                class="dropdown-item"
                href="#"
                id="creator"
                v-on:click.prevent="requestKeyChange('creator')"
              >
                Creator
                <span v-if="filterKey === 'creator'">&#x2713;</span>
              </a>

              <a
                v-if="selectedType === 'genome'"
                class="dropdown-item"
                href="#"
                id="b_number"
                v-on:click.prevent="requestKeyChange('b_number')"
              >
                B Number
                <span v-if="filterKey === 'b_number'">&#x2713;</span>
              </a>

              <a
                v-if="selectedType === 'genome'"
                class="dropdown-item"
                href="#"
                id="locus_tag"
                v-on:click.prevent="requestKeyChange('locus_tag')"
              >
                Locus Tag
                <span v-if="filterKey === 'locus_tag'">&#x2713;</span>
              </a>

              <a
                v-if="selectedType === 'genome'"
                class="dropdown-item"
                href="#"
                id="old_locus_tag"
                v-on:click.prevent="requestKeyChange('old_locus_tag')"
              >
                Old Locus Tag
                <span v-if="filterKey === 'old_locus_tag'">&#x2713;</span>
              </a>

              <a
                v-if="selectedType !== 'cart'"
                class="dropdown-item"
                href="#"
                id="seq"
                v-on:click.prevent="requestKeyChange('seq')"
              >
                Sequence
                <span v-if="filterKey === 'seq'">&#x2713;</span>
              </a>
            </div>
            <!-- .dropdown-menu -->
          </div>
          <!-- search-group-btn -->
        </div>
        <!-- input-group my-2 -->

        <div class="navbar-brand text-truncate">
          <!-- Placeholder for user profile-->
          <button
            type="button"
            class="btn btn-outline-danger ml-1"
            data-toggle="modal"
            data-target="#userProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="id-badge" />
          </button>
          <button
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#infoProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="info" />
          </button>
          <span class="h4 text-success text-capitalize ml-2"
            >{{ selectedTypeName }} Information System</span
          >
        </div>
        <!-- navbar-brand text-truncate -->

        <div class="navbar-text ml-auto d-flex">
          <!-- Project profile button -->
          <button
            v-if="selectedProject"
            type="button"
            class="btn btn-outline-success ml-1"
            data-toggle="modal"
            data-target="#projectProfile"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="project-diagram" />
          </button>

          <!-- cart button -->
          <div v-if="selectedCart" class="ml-1">
            <button
              type="button"
              class="btn btn-outline-success ml-1"
              data-toggle="modal"
              data-target="#cartProfile"
              data-backdrop="static"
              data-keyboard="false"
            >
              <span v-if="!cartIsFull" class="badge badge-pill badge-light">{{
                cartQty
              }}</span>
              <span v-if="cartIsFull" class="badge badge-pill badge-danger">{{
                cartQty
              }}</span>
              <font-awesome-icon icon="shopping-cart" />
            </button>
          </div>
          <!-- package button -->
          <div v-else-if="selectedPackage" class="ml-1">
            <button
              type="button"
              class="btn btn-outline-success ml-1"
              data-toggle="modal"
              data-target="#packageProfile"
              data-backdrop="static"
              data-keyboard="false"
            >
              <span
                v-if="!packageIsFull"
                class="badge badge-pill badge-light"
                >{{ packageQty }}</span
              >
              <span
                v-if="packageIsFull"
                class="badge badge-pill badge-danger"
                >{{ packageQty }}</span
              >
              <font-awesome-icon icon="box-open" />
            </button>
          </div>
        </div>
        <!-- .navbar-text ml-auto d-flex -->

        <div v-if="error" class="col-12 alert alert-danger px-3">
          {{ error }}
        </div>
        <div v-if="infoMessage" class="col-12 alert alert-info px-3">
          <span>{{ infoMessage }}</span>
          <span class="mx-2 spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </span>
        </div>
      </nav>
      <!-- sticky-top -->

      <!-- userProfile -->
      <OlabUserProfile :user="user" />

      <!-- infoProfile -->
      <OlabInfoProfile
        :user="user"
        :selectedTypeName="selectedTypeName"
        :selectedCart="selectedCart"
        :selectedPackage="selectedPackage"
      />

      <!-- projectProfile -->
      <OlabProjectProfile :user="user" :project="selectedProject" />

      <!-- cartProfile -->
      <OlabCartProfile
        :user="user"
        :selectedProject="selectedProject"
        :selectedCart="selectedCart"
      />

      <!-- packageProfile -->
      <OlabPackageProfile :user="user" :selectedPackage="selectedPackage" />

      <div class="modal fade" id="addNewItem">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Add:
                <span class="text-dark text-truncate">
                  {{ selectedTypeName }}
                </span>
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!-- .modal-header -->
            <div class="modal-body">
              <form>
                <fieldset class="form-group">
                  <!-- <legend>{{ selectedType }} Info</legend> -->
                  <div class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Name:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <input
                      class="form-control"
                      v-bind:class="item.getValidState(item.name)"
                      type="text"
                      v-model="item.name"
                    />
                    <!-- <div class="invalid-feedback">{{ invalidFB.name }}</div> -->
                  </div>
                  <div v-if="selectedType === 'cart'" class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Project ID:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      v-bind:class="item.getValidState(item.project_id)"
                      v-model="item.project_id"
                    >
                      <option disabled value="null">Please select one</option>
                      <option v-for="pj in projects" :key="pj.olab_id"
                        >{{ pj.olab_id }}&nbsp; - &nbsp;{{ pj.name }}</option
                      >
                    </select>
                    <!-- <span>selected = {{item.project_id}}</span> -->
                  </div>
                  <div v-if="selectedType === 'package'" class="form-group">
                    <label class="form-control-label font-italic">
                      <span>Package Type:</span>
                      <span class="small text-danger">*</span>
                    </label>
                    <div class="my-1">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="library_sequence"
                          v-model="item.package_seq_type"
                        />
                        <label class="form-check-label">
                          Library Sequence
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="genome"
                          v-model="item.package_seq_type"
                        />
                        <label class="form-check-label">
                          Genome
                        </label>
                      </div>
                    </div>
                    <select
                      class="form-control"
                      v-bind:class="item.getValidState(item.package_type)"
                      v-model="item.package_type"
                    >
                      <option disabled value="null">Please select one</option>
                      <option value="gene">Gene</option>
                      <option value="promoter">Promoter</option>
                      <option
                        v-if="item.package_seq_type == 'library_sequence'"
                        value="rbs"
                        >RBS</option
                      >
                      <option value="terminator">Terminator</option>
                    </select>
                    <!-- <span>selected = {{item.project_id}}</span> -->
                  </div>
                  <div class="form-group">
                    <label class="form-control-label font-italic"
                      >Creator:</label
                    >
                    <span class="ml-1">{{ item.creator }}</span>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label font-italic"
                      >Description:</label
                    >
                    <textarea
                      class="form-control"
                      v-model="item.desc"
                    ></textarea>
                  </div>
                </fieldset>
                <!-- .form-group -->
              </form>
            </div>
            <!-- .modal-body -->

            <div class="modal-footer">
              <button
                type="button"
                v-bind:disabled="itemAddIsDisabled == true"
                class="btn btn-primary"
                data-dismiss="modal"
                v-on:click="handleAddItem(item)"
              >
                Add
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
            <!-- .modal-footer -->
          </div>
          <!-- .modal-content -->
        </div>
        <!-- .modal-dialog .modal-lg-->
      </div>
      <!-- .modal fade addNewItem -->

      <div v-if="selectedType === 'genome'">
        <CompDBGeneList
          v-if="user"
          :user="user"
          :genes="selected.genes"
          :saveStatus="saveStatus"
          :error="error"
          :selectedType="selectedType"
          :selectedCart="selectedCart"
          :selectedPackage="selectedPackage"
          :cartIsFull="cartIsFull"
          :packageIsFull="packageIsFull"
          @doAddToComps="doAddToComps"
        />
      </div>
      <div v-else>
        <CompDBItemList
          v-if="user"
          :user="user"
          :dbInfo="dbInfo"
          :projects="projects"
          :strains="strains"
          :libraries="libraries"
          :error="error"
          :selectedItems="selected.items"
          :selectedType="selectedType"
          :selectedTypeName="selectedTypeName"
          :item="item"
          :selectedCart="selectedCart"
          :selectedPackage="selectedPackage"
          :cartIsFull="cartIsFull"
          :packageIsFull="packageIsFull"
          @doSelectCart="doSelectCart"
          @doAddToComps="doAddToComps"
          @doCloneItem="doCloneItem"
          @doSelectPackage="doSelectPackage"
        />
      </div>
      <div class="my-5">
        <nav aria-label="Page navigation">
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <button
                type="button"
                v-bind:disabled="selected.prevIsDisabled == true"
                class="btn btn-primary"
                v-on:click="handlePrev()"
              >
                &lt;
              </button>
            </li>
            <li class="mx-3">{{ selected.pageNumber }}</li>
            <li class="page-item">
              <button
                type="button"
                v-bind:disabled="selected.nextIsDisabled == true"
                class="btn btn-primary"
                v-on:click="handleNext()"
              >
                &gt;
              </button>
            </li>
          </ul>
        </nav>
        <div
          v-if="
            searchTerm &&
              searchTerm.length < 5 &&
              filterKey == 'merge' &&
              selected.nextRecRef
          "
          class="text-center"
        >
          <small
            >Merge search browsing may miss finding if search string is too
            short.</small
          >
        </div>
      </div>
    </div>
    <div v-else class="mt-5">
      <div class="text-secondary text-center">
        <div class="h2">Inactivity Time Out</div>
        <router-link
          class="btn btn-outline-primary mt-2"
          to="/login"
          v-if="!user"
          >Log in</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import CompDBGeneList from "@/components/CompDBGeneList";
import CompDBItemList from "@/components/CompDBItemList";
import OlabUserProfile from "@/components/OlabUserProfile";
import OlabInfoProfile from "@/components/OlabInfoProfile";
import OlabProjectProfile from "@/components/OlabProjectProfile";
import OlabCartProfile from "@/components/OlabCartProfile";
import OlabPackageProfile from "@/components/OlabPackageProfile";
// import _ from "lodash";
import { OlabItem } from "../olab/olabitem.js";
import { OlabCart } from "../olab/olabcart.js";
import { OlabPackage } from "../olab/olabpackage.js";
import { OlabUtils } from "../olab/olabutils.js";
import { OlabSearch } from "../olab/olabsearch.js";
import db from "../olab/db.js";
// import firebase from "firebase";
// import $ from "jquery";

export default {
  name: "compdb",
  data: function() {
    return {
      title: "Component",
      cartItems: [],
      searchTerm: "",
      filterKey: "merge",
      filterDir: "asc",
      selectedType: "genome",
      lastSelectedType: null,
      selectedTypeName: "Genome",
      item: new OlabItem(),
      selected: {
        genes: null,
        items: null,
        collectionRef: null,
        collectionOrderBy: "olab_id",
        pageNumber: 1,
        nextRecRef: null,
        nextIsDisabled: true,
        // This is an array of prev page refs
        prevRecRefArr: [],
        prevIsDisabled: true
      }
      // searchHelper: new OlabSearch()
    };
  },
  components: {
    FontAwesomeIcon,
    CompDBGeneList,
    CompDBItemList,
    OlabUserProfile,
    OlabInfoProfile,
    OlabProjectProfile,
    OlabCartProfile,
    OlabPackageProfile
  },
  props: [
    "user",
    "dbInfo",
    "infoMessage",
    "saveStatus",
    "projects",
    "strains",
    "libraries",
    "selectedProject",
    "selectedCart",
    "selectedPackage",
    "error"
  ],
  mounted: function() {
    OlabUtils.infoLog("CompDB mounted ...");
    this.loadGenomes();
  },
  computed: {
    itemAddIsDisabled: function() {
      switch (this.selectedType) {
        case "cart":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator) ||
            !this.item.isValid(this.item.project_id)
          );
        // break;
        case "package":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator) ||
            !this.item.isValid(this.item.package_type)
          );
        // break;
      }
      return false;
    },
    cartTotal: function() {
      let sum = 0;
      if (this.selectedCart != null && this.selectedCart.comps != null) {
        for (let idx in this.selectedCart.comps) {
          sum =
            sum +
            this.selectedCart.comps[idx].length *
              this.selectedCart.comps[idx].qty;
        }
      }
      return sum;
    },
    cartQty: function() {
      let qty = 0;
      if (this.selectedCart != null && this.selectedCart.comps != null) {
        for (let idx in this.selectedCart.comps) {
          qty = qty + this.selectedCart.comps[idx].qty;
        }
        if (qty >= OlabUtils.MAX_ITEMS_PER_CART) {
          return "FULL";
        }
      }
      return qty;
    },
    cartIsFull: function() {
      return this.cartQty === "FULL" ? true : false;
    },
    packageTotal: function() {
      let sum = 0;
      if (this.selectedPackage != null && this.selectedPackage.comps != null) {
        for (let idx in this.selectedPackage.comps) {
          sum =
            sum +
            this.selectedPackage.comps[idx].length *
              this.selectedPackage.comps[idx].qty;
        }
      }
      return sum;
    },
    packageQty: function() {
      let qty = 0;
      if (this.selectedPackage != null && this.selectedPackage.comps != null) {
        for (let idx in this.selectedPackage.comps) {
          qty = qty + this.selectedPackage.comps[idx].qty;
        }
        if (qty >= OlabUtils.MAX_ITEMS_PER_PACKAGE) {
          return "FULL";
        }
      }
      return qty;
    },
    packageIsFull: function() {
      return this.packageQty === "FULL" ? true : false;
    }
  },
  filters: {
    searchFilter: function(value) {
      switch (value) {
        case "merge":
          return "Merge";
        case "olab_id":
          return "OLAB ID";
        case "name":
          return "Name";
        case "creator":
          return "Creator";
        case "b_number":
          return "B Number";
        case "locus_tag":
          return "Locus";
        case "old_locus_tag":
          return "Old Locus";
        case "seq":
          return "Sequence";
      }
    },
    convertToK: function(value) {
      if (value > 999) {
        value = Number.parseFloat(value / 1000).toFixed(2) + "K";
      }
      return value;
    }
  },
  methods: {
    handlePrev: function() {
      OlabUtils.infoLog("handlePrev ...");
      OlabSearch.doPrev(this.selectedType, this.selected);
    },
    handleNext: function() {
      OlabUtils.infoLog("handleNext ...");
      OlabSearch.doNext(this.selectedType, this.selected);
    },
    updateSelectedPackage: function() {
      const pkgRef = "packages/PG/olab_items";
      this.$emit("setSaveStatus", true);
      db.collection(pkgRef)
        .withConverter(OlabPackage.getUpdatePackageConverter())
        .doc(this.selectedPackage.olab_id)
        .set(this.selectedPackage, { merge: true })
        .then(
          function() {
            OlabUtils.infoLog(
              "updateSelectedPackage: Document successfully written!"
            );
            this.$emit("setSaveStatus", false);
          }.bind(this)
        )
        .catch(
          function(error) {
            OlabUtils.infoLog(
              "updateSelectedPackage: Error writing document: " + error
            );
            this.error = error;
          }.bind(this)
        );
    },
    deletePackageComp: function(idx) {
      if (this.selectedPackage.comps[idx].qty > 1) {
        this.selectedPackage.comps[idx].qty--;
      } else {
        this.selectedPackage.comps.splice(idx, 1);
      }
      this.updateSelectedPackage();
    },
    requestTypeChange: function(value) {
      this.selectedType = value;
      OlabUtils.infoLog("requestTypeChange " + this.selectedType);
      if (this.selectedType !== this.lastSelectedType) {
        // Reset searchTerm when type changed
        this.searchTerm = "";

        OlabUtils.infoLog("Watch - selectedType = " + this.selectedType);

        switch (this.selectedType) {
          case "cart":
            this.selectedTypeName = "Cart";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "package":
            this.selectedTypeName = "Package";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "genome":
            this.selectedTypeName = "Genome";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
          case "library_sequence":
            this.selectedTypeName = "Sequence";
            this.searchTerm = "";
            this.doSearchTerm(this.searchTerm, this.selectedType);
            break;
        }
        this.lastSelectedType = this.selectedType;
      }
    },
    requestKeyChange: function(value) {
      this.filterKey = value;
      this.doSearchTerm(this.searchTerm, this.selectedType);
    },
    loadGenomes: function() {
      // Load selected.genes if it is null
      if (this.selected.genes == null) {
        this.searchTerm = "";
        this.selectedType = "genome";
        this.doSearchTerm(this.searchTerm, this.selectedType);
      }
    },
    prepAddItem: function(item) {
      OlabUtils.infoLog("prepAddItem");
      item.initItem();
      // initialize creator with user's email
      item.creator = this.user.email;
    },
    handleAddItem: function(item) {
      OlabUtils.infoLog(
        "Add item = " + item + ", selectedType = " + this.selectedType
      );

      this.$emit("addItem", {
        item: item,
        type: this.selectedType,
        items: this.selected.items
      });
    },
    doCloneItem: function(item) {
      OlabUtils.infoLog(
        "doCloneItem item = " + item + ", selectedType = " + this.selectedType
      );

      this.$emit("addItem", {
        item: item,
        type: this.selectedType,
        items: this.selected.items
      });
    },
    doSelectCart: function(cart) {
      OlabUtils.infoLog("doSelectCart cart = " + cart);
      this.$emit("selectCart", cart);
    },
    doAddToComps: function({ item, useSeqAs }) {
      OlabUtils.infoLog(
        "doAddToComps item.olab_id = " +
          item.olab_id +
          ", useSeqAs = " +
          useSeqAs
      );

      let comps;
      if (this.selectedCart) {
        comps = this.selectedCart.comps;
      } else if (this.selectedPackage) {
        comps = this.selectedPackage.comps;
      } else {
        OlabUtils.infoLog(
          "doAddToComps: Error! No selectedCart nor selectedPackage"
        );
      }

      // OlabUtils.infoLog("doAddToComps: comps.length = " + comps.length);
      // comps.forEach(ele => {
      //   OlabUtils.infoLog("  olab_id = " + ele.olab_id + ", useSeqAs = " + ele.use_seq_as + ", qty = " + ele.qty);
      // });

      let whichItem;
      let existing = comps.filter(function (ele, index) {
        // console.log("ele.olab_id = " +  ele.olab_id);
        // console.log("item.olab_id = " +  Number(item.olab_id));
        if (ele.olab_id == item.olab_id && ele.use_seq_as.match(useSeqAs)) {
          // console.log("index = " + index);
          // console.log("ele.use_seq_as = " + ele.use_seq_as);
          // console.log("useSeqAs = " +  useSeqAs);

          whichItem = index;
          return true;
        } else {
          return false;
        }
      });
      // console.log("existing.length = " + existing.length);
      if (existing.length) {
        // console.log("existing = " + existing[0].olab_id);
        comps[whichItem].qty++;
        comps[whichItem].available_count++;
      } else {
        let cObj = {
          olab_id: item.olab_id,
          olab_type: item.olab_type,
          name: item.name,
          b_number: item.b_number ? item.b_number : null,
          locus_tag: item.locus_tag ? item.locus_tag : null,
          old_locus_tag: item.old_locus_tag ? item.old_locus_tag : null,
          length: item.length ? item.length : null,
          use_seq_as: useSeqAs,
          qty: 1,
          available_count: 1,
          used_count: 0
        };
        // Only add seq data to package item
        if (!this.selectedCart) {
          if (item.olab_type == "strain") {
            cObj.seq = item.sequence.seq;
            // For Genome Package Case to hold gene's seq support data
            cObj.seqGene = null;
          } else {
            cObj.seq = item.seq;
          }
          // OlabUtils.infoLog("doAddToComps: cObj.seq = " + cObj.seq);
        }
        comps.push(cObj);
      }
      if (this.selectedCart) {
        OlabCart.saveCart(this.selectedCart, this.selectedProject);
      } else if (this.selectedPackage) {
        this.updateSelectedPackage();
      }
    },
    doSelectPackage: function(pkg) {
      OlabUtils.infoLog("doSelectPackage pkg = " + pkg);
      this.$emit("selectPackage", pkg);
    },
    doSearchTerm: function(sTerm, sType) {
      OlabUtils.infoLog(
        "doSearchTerm - sTerm = " +
          sTerm +
          ", sType = " +
          sType +
          ", filterKey = " +
          this.filterKey
      );
      OlabSearch.doSearchTerm(
        sTerm,
        sType,
        this.filterKey,
        null,
        this.selected
      );
    }
  },
  watch: {
    searchTerm: function() {
      OlabUtils.infoLog("Watch - searchTerm = " + this.searchTerm);
      this.doSearchTerm(this.searchTerm, this.selectedType);
    }
  }
};
</script>
